import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import Api from '../utils/api'

export default new Vuex.Store({

  state: {
    config: {
      scenes: [],
      series: [],
      product_cats: [],
      fabric_cats: [],
      type_cats: [],
      module_types: [],
      video_types: [],
      catalog_types: [],
      page: {}
    },
    // ---------woods ---------------
    mainItems: {},
    auxiliaryItems: {},
    // ---------woods ---------------
    // ---------Modules ---------------
    ModuleItems: [],
    // ---------Modules ---------------
  },
  getters: {
    getScenes: (state) => state.config['scenes'],
    getSeries: (state) => state.config['series'],
    getPageData: (state) => state.config['page'],
    getPageBanner: (state) => (pos) => state.config['page'][pos],
    getTypeCats: (state) => state.config['type_cats'],
    getCatalogTypes: (state) => state.config['catalog_types'],
    getVideoTypes: (state) => state.config['video_types'],
    getModuleTypes: (state) => state.config['module_types'],
    getFabricCats: (state) => state.config['fabric_cats'],
    getProductCats: (state) => {
      let arr = state.config['product_cats'];
      const ll = [];
      let chunkSize = 6
      for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        ll.push(chunk);
      }
      return ll;
    },

    getBrands: (state) => {
      let arr = state.config['series'];
      const ll = [];
      let chunkSize = 5
      for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        ll.push(chunk);
      }
      return ll;
    },

  },
  mutations: {
    setupApp(state, data) {
      state.config['scenes'] = data['scenes']
      state.config['series'] = data['series']
      state.config['product_cats'] = data['product_cats']
      state.config['type_cats'] = data['type_cats']
      state.config['fabric_cats'] = data['fabric_cats']
      state.config['video_types'] = data['video_types']
      state.config['module_types'] = data['module_types']
      state.config['catalog_types'] = data['catalog_types']
      state.config['page'] = data['page']
    },
    // ---------woods ---------------
    // ---------modules ---------------
    setupModuleItems(state, data) {
      state.ModuleItems = data.items
    }

  },
  actions: {
    initApp({ commit }) {
      Api.getMenus().then(data => {
        commit('setupApp', data)
      })
    },
    // ---------module ---------------
    queryModuleList({ commit }, args = { pg: 1, per_page: 20 }) {
      Api.getModuleList(args).then(data => {
        commit('setupModuleItems', data)
      })
    },
    // ---------module ---------------
    // ---------woods ---------------
    queryWoods({ commit }, args) {
      Api.getWoods(args).then(res => {
        console.log('aaaa', res);
      })
    }
    // ---------woods ---------------

  },

})
